import { ActionTree } from 'vuex'
import { ContactInfoState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<ContactInfoState, RootState> = {
}
